export default "/img/logo.mobile.truckdown.png";